import { InnerBlocks } from '@wordpress/block-editor';

/**
 * The wrapper, the icon and the dismiss button are all built by render.php, so
 * the saved markup is the author's content and nothing else. Keeping the
 * chrome on the server means changing it later does not invalidate every
 * notice already published.
 */
export default function Save() {
  return <InnerBlocks.Content />;
}
